import { useEffect, useState } from "react";
import { getEffectiveUserData } from "../utils/activeProfileStorage";

/** Updates when header profile switch dispatches `activeProfileChanged`. */
export function useEffectiveUserData(): Record<string, any> {
  const [userData, setUserData] = useState<Record<string, any>>(() =>
    getEffectiveUserData()
  );

  useEffect(() => {
    const sync = () => setUserData(getEffectiveUserData());
    window.addEventListener("activeProfileChanged", sync);
    return () => window.removeEventListener("activeProfileChanged", sync);
  }, []);

  return userData;
}
